import { REQUIRED } from "../../constants/validations";

const validations = (values) => {
  let errors = {};

  if (!values.occupancy_at_closing) {
    errors.occupancy_at_closing = REQUIRED;
  }

  if (!values.suburban_or_rural) {
    errors.suburban_or_rural = REQUIRED;
  }

  if (!values.impounds) {
    errors.impounds = REQUIRED;
  }

  if (!values.coe_date) {
    errors.coe_date = REQUIRED;
  }

  if (!values.exit_strategy) {
    errors.exit_strategy = REQUIRED;
  }

  if (!values.exit_repay_loan) {
    errors.exit_repay_loan = REQUIRED;
  }

  return errors;
};

export default validations;



// WEBPACK FOOTER //
// ./src/Screens/ConsoleBrok/validations3.js